export default "__VITE_ASSET__ChEYwbmf__"